import { parse } from "date-fns";

import {
  GoalBasedFinancialPlanGoalResponse,
  GoalBasedFinancingMethodSchema,
} from "@fartherfinance/frontend/api/FinancialPlans/goals/types";
import { GoalBasedFinancialPlanRetirementHorizonResponse } from "@fartherfinance/frontend/api/FinancialPlans/retirementHorizon/types";

import { GoalOwnerFieldType } from "../../Goals/Forms/types";
import {
  AnnualIncreaseAmountField,
  AnnualIncreaseTypeField,
  annualIncreaseTypeOptions,
  isCustomInflation,
} from "../MultiDropdown/AnnualIncrease/AnnualIncrease";
import {
  AmountField,
  AnnualAmountField,
  CostOfSaleField,
  DateOfBirthField,
  defaultPlanDateFieldValues,
  DownPaymentField,
  FinancingMethodField,
  FinancingTermField,
  InterestRateField,
  NameField,
  OwnerField,
  PlanningHorizonField,
  PurchasePriceField,
  ResidualValueField,
  TargetAmountField,
  TargetRetirementAgeField,
  YearOfSaleField,
} from "@src/multiCustodian/components/FinancialPlans/CreateUpdatePlanFlow/pages/Shared/constants";

import { getInitialPlanDateFieldValuesForForm } from "./getInitialPlanDateFieldValuesForForm";

export const populateSelectedGoalFormFields = (
  defaultOwner: GoalOwnerFieldType,
  selectedGoal: GoalBasedFinancialPlanGoalResponse,
  retirementHorizons?: GoalBasedFinancialPlanRetirementHorizonResponse[]
) => {
  const {
    name,
    amount,
    financeMethod,
    annualIncrease,
    financing,
    owner,
    startDate,
    endDate,
    dateOfBirth,
  } = {
    ...selectedGoal,
  };

  const annualIncreaseField = annualIncreaseTypeOptions.find(
    ({ value }) => annualIncrease?.type === value
  );

  const annualIncreaseAmountField = isCustomInflation(annualIncrease)
    ? annualIncrease.value
    : undefined;

  const { Cash, Loan, Lease } = GoalBasedFinancingMethodSchema.Enum;

  const getFinanceMethodOption = () => {
    switch (financeMethod) {
      case Cash:
        return { label: Cash, value: Cash };
      case Loan:
        return { label: Loan, value: Loan };
      default:
        return { label: Lease, value: Lease };
    }
  };

  const getRepeatDropdownFormFieldValues = () => {
    if (retirementHorizons === undefined) {
      return { ...defaultPlanDateFieldValues };
    }

    return getInitialPlanDateFieldValuesForForm({
      clientId: owner,
      retirementHorizons,
      existingCategoryElement: selectedGoal,
      dateOfBirth: defaultOwner.dob ?? undefined,
    });
  };

  const form = {
    [OwnerField]: defaultOwner,
    [NameField]: name,
    [AmountField]: amount,
    [AnnualAmountField]: amount,
    [PurchasePriceField]: amount,
    [TargetAmountField]: amount,
    [DateOfBirthField]: dateOfBirth
      ? parse(dateOfBirth, "yyyy/MM/dd", new Date())
      : undefined,
    [PlanningHorizonField]: endDate?.value,
    [TargetRetirementAgeField]: startDate?.value,
    [AnnualIncreaseTypeField]: annualIncreaseField,
    [AnnualIncreaseAmountField]: annualIncreaseAmountField,
    [FinancingMethodField]: getFinanceMethodOption(),
    [DownPaymentField]: financing?.downPayment,
    [FinancingTermField]: financing?.term,
    [InterestRateField]: financing?.interestRate,
    [ResidualValueField]: financing?.residualValue,
    [YearOfSaleField]: financing?.yearOfSale
      ? parse(financing?.yearOfSale, "yyyy", new Date())
      : undefined,
    [CostOfSaleField]: financing?.costOfSale,
    ...getRepeatDropdownFormFieldValues(),
  };

  return form;
};
